import React, { useState } from 'react';
import SimpleButton from './SimpleButton';
import FadeUp from './animations/FadeUp';
import HeroText from './HeroText';
import SalesforceForm from './SalesforceForm';
import Complete from './animations/Complete';

const SignUp: React.FC = () => {
    const inputStyle = "p-2 md:p-4 rounded border border-gray-600 font-jarkarta bg-transparent text-white placeholder-white focus:ring-ekc-green block w-full appearance-none focus:outline-none focus:ring-0 focus:border-ekc-green peer";
    const labelStyle = "absolute text-sm bg-custom-black text-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] px-2 peer-focus:px-2 peer-focus:text-ekc-green peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 pointer-events-none";
    const formFields = (
        <div className='grid md:grid-cols-2 gap-4 w-full'>
            <div className="relative md:col-span-2">
                <input type="text" placeholder="" name="name" required className={`${inputStyle} md:col-span-2`} />
                <label htmlFor="name" className={labelStyle}>Name<span className="text-red-500">*</span></label>
            </div>
            <div className="relative">
                <input type="email" placeholder="" name="email" required className={`${inputStyle}`} />
                <label htmlFor="email" className={labelStyle}>Email<span className="text-red-500">*</span></label>
            </div>
            <div className="relative">
                <input type="text" placeholder="" name="zip" required pattern="[0-9]*" className={`${inputStyle}`} />
                <label htmlFor="zip" className={labelStyle}>Zip Code<span className="text-red-500">*</span></label>
            </div>
            <div className="relative">
                <input type="tel" placeholder="" name="phone" className={`${inputStyle}`} />
                <label htmlFor="phone" className={labelStyle}>Phone Number</label>
            </div>
            <div className="relative">
                <input type="text" placeholder="" name="company" className={`${inputStyle}`} />
                <label htmlFor="company" className={labelStyle}>Company</label>
            </div>
            <div className="relative md:col-span-2">
                <textarea placeholder="" name="description" className={`${inputStyle} md:col-span-2`} />
                <label htmlFor="description" className={labelStyle}>Message</label>
            </div>
            {/* If you need to send a hidden field, include it here. Example for a hidden input that might carry over a pageName or similar */}
            <input type="hidden" name="page_name" value="SignUpPage" className={`${inputStyle}`} />
        </div>
    );
    const submitButton = (
        <SimpleButton
            size="medium"
            label="Sign Up"
            textColor="text-white"
            bgColor="bg-custom-black hover:bg-ekc-green w-full border border-gray-600 transition duration-300"
            onClick={() => { }}
            roundness=''
            fullWidth={true}
            growScale={1}
        />
    );
    const [isSubmitted, setIsSubmitted] = useState(false);

    const checkSubmission = (submitted: boolean) => {
        if (submitted) {
            setIsSubmitted(true);
        }
    };
    return (
        <div className="pb-32 lg:pb-52 bg-custom-black font-jarkarta z-20 relative text-white">
            <FadeUp>
                <div className="max-w-6xl mx-auto container">
                    <HeroText
                        tagline="Join Our Community"
                        title="Would You Like to Make a Difference?"
                        subtitle="Join the growing network of leaders, innovators, and visionaries who are helping to establish Kansas and Western Missouri as a destination. By signing up you will have exclusive access to our latest progress reports, and new opportunities for collaboration. Let’s shape our region’s future together!"
                        darkMode={true}
                        className='flex flex-col items-center justify-center text-center'
                    />
                    <div className="bg-dark-overlay rounded-lg py-8 max-w-3xl mx-auto">
                        {isSubmitted ? (
                            <div className="flex justify-center items-center h-full">
                                <div className="text-center">
                                    <Complete
                                        onComplete={() => { }}
                                        text="We got your message!"
                                    />
                                </div>
                            </div>
                        ) : (
                            <SalesforceForm
                                debug={true}
                                page="LandingPage"
                                children={formFields}
                                button={submitButton}
                                enableReCAPTCHA={false}
                                submissionCheck={checkSubmission}
                                formStyle='flex flex-col justify-start md:justify-center items-center w-full'
                                loadingCallback={() => { }}
                            />
                        )}
                    </div>
                </div>
            </FadeUp>
        </div>
    );

};

export default SignUp;
